import { render, staticRenderFns } from "./VerdictScale.vue?vue&type=template&id=0780acf6&scoped=true"
import script from "./VerdictScale.vue?vue&type=script&lang=js"
export * from "./VerdictScale.vue?vue&type=script&lang=js"
import style0 from "./VerdictScale.vue?vue&type=style&index=0&id=0780acf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780acf6",
  null
  
)

export default component.exports